import { render, staticRenderFns } from "./ConfirmReceivingGoods.vue?vue&type=template&id=f5df261a&scoped=true&"
import script from "./ConfirmReceivingGoods.vue?vue&type=script&lang=js&"
export * from "./ConfirmReceivingGoods.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmReceivingGoods.vue?vue&type=style&index=0&id=f5df261a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5df261a",
  null
  
)

export default component.exports